<!--
 * @Author: wjl
 * @Date: 2020-08-26 11:10:18
 * @LastEditors: wjl
 * @LastEditTime: 2020-12-17 14:52:04
 * @FilePath: \appOfficial\src\views\PayIssue.vue
-->
<template>
  <div class="contrainer" :style="isPc ? 'width:1100px' : ''">
    <h1>网上老年大学常见充值问题</h1>
    <h2>1.如何查看我的充值记录？</h2>
    <p>点击「我的」-「钱包」-「充值」-「充值记录」，即可看到您的充值记录。</p>
    <h2>2.付款成功，但学币没有到账怎么办？</h2>
    <p>2.1 由于网络原因可能导致学币到账延迟，滞后属于正常现象，请耐心等候</p>
    <p>
      2.2
      如超过90分钟仍未到账，请在「我的」-「联系客服」提供您的手机号码和充值记录截图，工作人员尽快帮您核查。
    </p>
    <h2>3.提示“充值失败”，充值遇到问题？</h2>
    <p>3.1 请检查付款时间网络是否连接正常；</p>
    <p>3.2 请关闭APP程序，重新打开APP；</p>
    <p>3.3 请关机进行重启，重新打开APP；</p>
    <p>
      3.4
      如问题仍未解决，请将提示“充值失败”的页面截图通过「我的」-「联系客服」提交给我们，我们会尽快查看。
    </p>
    <h2>4.充错账户，充错金额数值怎么办？</h2>
    <p>
      学币是网上老年大学平台向您提供的用于在网上老年大学平台上进行相关消费的虚拟货币，依据法律属于数字化商品，不适用七天无理由退货的规定，同时，基于金融监管的要求，虚拟活动不能逆向兑换为人民币，故学币购买后无法再退款，账号内“学币”可由您在本平台上自由使用。
    </p>
  </div>
</template>

<script>
export default {
  name: "issue",
  data() {
    return {
      isPc: true,
    };
  },
  mounted() {
    this.isPc = this.modoule();
  },
  methods: {
    modoule() {
      var userAgentInfo = navigator.userAgent;
      var Agents = new Array(
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod"
      );
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    },
  },
};
</script>

<style lang="scss" scoped>
.contrainer {
  padding: 20px;
  padding-top: 0;
  margin: 0 auto;
}
h1 {
  font-size: 16pt;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
  color: black;
  line-height: 16.5pt;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
h2 {
  font-size: 15pt;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: black;
  line-height: 16.5pt;
  margin: 10px 0;
}
h3 {
  font-size: 14pt;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: black;
  line-height: 16.5pt;
  margin: 15px 0;
}
p {
  font-size: 12.5pt;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: black;
  line-height: 18.5pt;
  text-align: justify;
  text-indent: 2.66vw;
  span {
    font-weight: 600;
  }
}
</style>
